import {http} from './config/config-relation-register'

export default{
    listar:async(token,itens_pagina,pagina)=>{
        if(itens_pagina,pagina){
            return  http.get('culturas?itens_pagina='+itens_pagina+'&pagina='+pagina,{
                headers:{
                    'Authorization':token
                }
            }) 
        }else{
            return  http.get('culturas',{
                headers:{
                    'Authorization':token
                }
            })
        }
    },
    salvar:(token, item)=>{
        return http.post('culturas',item,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idItem)=>{
        return http.delete('culturas/'+idItem,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, item)=>{
        return http.put('culturas/'+item.id_cultura,item,{
            headers:{
                'Authorization':token
            }
        })
    }

}